import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';

type UpdateGameRulesVersionRequest = {
  id: string;
  title?: string;
  version?: string;
  type?: string;
  rules_text?: string;
  is_default?: boolean;
  status?: string;
};

type GameRulesVersion = {
  id: string;
  title: string;
  version?: string;
  type: string;
  rules_text: string;
  is_default: boolean;
  status: string;
  created_at: string;
  updated_at: string;
};

type UpdateGameRulesVersionResponse = {
  rules_version: GameRulesVersion;
};

export const updateGameRulesVersion = (
  data: UpdateGameRulesVersionRequest
): Promise<UpdateGameRulesVersionResponse> =>
  apiClient.put(
    `/api/admin/squares/game-rules/${data.id}` as any,
    data
  ) as Promise<UpdateGameRulesVersionResponse>;

export const useUpdateGameRulesVersionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateGameRulesVersion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['game-rules'] });
    },
  });
};

// Backwards-compatible aliases
export const updateSquaresGameRulesVersion = updateGameRulesVersion;
export const useUpdateSquaresGameRulesVersionMutation = useUpdateGameRulesVersionMutation;
